import { useTranslation } from "react-i18next";
import { FileUploader } from "react-drag-drop-files";
import CONFIG from "../../config/config";
import { useState } from "react";
import { StyleSheetManager } from "styled-components";

/** Values for `{{name}}` placeholders in i18n strings. */
type I18nInterpolation = Record<string, string | number>;

type Props = {
  label?: string,
  /** Interpolation values for `label` (e.g. `{ maxSize: 2.5 }` when the label contains `{{maxSize}}`). */
  labelOptions?: I18nInterpolation,
  onChange: (input: any) => void,
  isDisabled?: boolean,
  allowedTypes?: string[],
  allowedMultipleFiles?: boolean,
  maxSize?: number,
  /** When set, the size error message includes {{maxSize}} (MB) via `errors.too_heavy_max_mb`. */
  showMaxSizeInSizeError?: boolean,
};

function FileUploadWrapper({ label = '', labelOptions, isDisabled = false, onChange = () => null, allowedTypes = CONFIG.FILE_TYPES, allowedMultipleFiles = false, maxSize = CONFIG.MAX_FILE_UPLOAD, showMaxSizeInSizeError = false }: Props) {

  const [error, setError] = useState<{ key: string; options?: I18nInterpolation } | undefined>();
  const { t } = useTranslation();
  
  const wrapOnChange = (params: any) => {
    setError(undefined);
    onChange(params);
  };

  const labelText =
    labelOptions != null
      ? (t(label, labelOptions) as string)
      : (t(label) as string);

  return (
    <div className="w-full max-w-full min-w-0">
      { error && (
        <p className="text-xs text-red-600 my-0">
          {(error.options != null
            ? t(error.key, error.options)
            : t(error.key)) as string}
        </p>
      )}
      <div className="w-full max-w-full min-w-0">
        <StyleSheetManager shouldForwardProp={(propName) => propName !== "error"}>
          <FileUploader 
            label={labelText} 
            handleChange={wrapOnChange} 
            name="file" 
            types={allowedTypes}
            maxSize={maxSize}
            disabled={isDisabled}
            multiple={allowedMultipleFiles}
            onSizeError={() => {
              console.error("File size error occurred.");
              setError(
                showMaxSizeInSizeError && maxSize != null
                  ? { key: "errors.too_heavy_max_mb", options: { maxSize } }
                  : { key: "errors.too_heavy" }
              );
            }}
          />
        </StyleSheetManager>
      </div>
    </div>
  );
}

export default FileUploadWrapper;
